import { createCallchainHttp } from './callchain-http.js'

let http
export function configurePromotionHttp(options) {
  http = createCallchainHttp({ ...options, basePath: '/api/visual-game/admin' })
}
export const listPromotions = (query = {}) => http.get('/promotions', { query, routeId: 'visualGame.promotions.list' })
export const savePromotion = (id, body) => id
  ? http.put(`/promotions/${encodeURIComponent(id)}`, { body, routeId: 'visualGame.promotions.update' })
  : http.post('/promotions', { body, routeId: 'visualGame.promotions.create' })
export const setTrialEnabled = trial_enabled => http.put('/promotion-settings', { body: { trial_enabled }, routeId: 'visualGame.promotions.switch' })
